import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'bem-classnames';

import {
  customPropTypes,
  childrenUtils,
  createShorthandFactory,
  getElementType,
  getUnhandledProps,
} from 'components/lib';

/* eslint-disable react/prefer-stateless-function */
class MenuItem extends React.Component {
  static propTypes = {
    /** An element type to render as (string or function). */
    as: customPropTypes.as,

    /** A menu item can be active. */
    active: PropTypes.bool,

    /** Primary content. */
    children: PropTypes.node,

    /** Additional classes. */
    className: PropTypes.string,

    /** Shorthand for primary content. */
    content: customPropTypes.contentShorthand,

    /** A menu item can be disabled. */
    disabled: PropTypes.bool,

    /** MenuItem index inside Menu. */
    index: PropTypes.number,

    /** A menu item can be link. */
    link: PropTypes.bool,

    /** Internal name of the MenuItem. */
    name: PropTypes.string,

    /**
     * Called on click. When passed, the component will render as an `a`
     * tag by default instead of a `div`.
     *
     * @param {SyntheticEvent} event - React's original SyntheticEvent.
     * @param {object} data - All props.
     */
    onClick: PropTypes.func,
  };

  static handledProps = ['active', 'content', 'index'];

  handleClick = e => {
    const { disabled } = this.props;

    if (!disabled) _.invoke(this.props, 'onClick', e, this.props);
  };

  render() {
    const { className, children, onClick, content, name, style } = this.props;
    const classes = cx(
      { name: 'menu__item', modifiers: ['active', 'disabled', 'link'] },
      this.props,
      className,
    );

    const ElementType = getElementType(MenuItem, this.props, () => {
      if (onClick) return 'a';
    });
    const rest = getUnhandledProps(MenuItem, this.props);

    if (!childrenUtils.isNil(children)) {
      return (
        <ElementType {...rest} className={classes} style={style} onClick={this.handleClick}>
          {children}
        </ElementType>
      );
    }

    return (
      <ElementType {...rest} className={classes} onClick={this.handleClick}>
        {childrenUtils.isNil(content) ? _.startCase(name) : content}
      </ElementType>
    );
  }
}

MenuItem.create = createShorthandFactory(MenuItem, val => ({
  content: val,
  name: val,
}));

export default MenuItem;
